import { Option } from '@repo/toolkit/types'
import SelectInput from '@repo/ui/select-input'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { getStaff } from '../../../api/staff/get-staff'
import useTranslate from '../../../lib/hooks/use-translate'
import {
  StaffPositionEnum,
  staffPositionEnumMapping
} from '../../../lib/types/enums/staff/staff-position.enum'
import { ContractFilters } from '../../../lib/types/models/contract/contract'
import { yearsFilterOptions } from '../../../views/pcr-personal-space/utils'

interface Props {
  staffId: number
  filter?: ContractFilters
  onFilterChange: (filter: ContractFilters) => void
}

export function ContractFilter({ staffId, filter, onFilterChange }: Props) {
  function setFilter<K extends keyof ContractFilters>(key: K, value: ContractFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { t } = useTranslate()

  const { data: staff, isPending } = useQuery({
    queryKey: ['staff', staffId, 'position'],
    queryFn: () => getStaff(staffId, 'POSITION')
  })

  const staffPosition = staff?.position

  const staffPositionOptions: Option<StaffPositionEnum>[] = useMemo(() => {
    if (!staffPosition) return []
    return [
      { label: t(staffPositionEnumMapping[StaffPositionEnum.AAT]), value: StaffPositionEnum.AAT },
      { label: t(staffPositionEnumMapping[staffPosition]), value: staffPosition }
    ]
  }, [t, staffPosition])

  return (
    <div className={'flex flex-col gap-4'}>
      <div />

      <SelectInput
        label="Année du séjour"
        options={yearsFilterOptions}
        selectedOption={
          filter?.year
            ? {
                label: yearsFilterOptions.find((y) => y.value === filter.year)?.label ?? '',
                value: filter.year
              }
            : undefined
        }
        onChange={(year) => setFilter('year', year)}
      />

      <SelectInput
        label={'Poste'}
        disabled={isPending}
        options={staffPositionOptions}
        selectedOption={staffPositionOptions.find((option) => option.value === filter?.position)}
        onChange={(value) => setFilter('position', value)}
      />
    </div>
  )
}
